var _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39c",
    d: "M0 0v40h60V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 26.7v2.2h60v-2.2zM0 31v2.2h60V31z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m11.6 3 .3.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M11.9 2.8 10 9.4l-6.5 1.8 6.5 1.7 1.8 6.5 1.7-6.5L20 11l-6.5-1.7-1.8-6.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/aw.efa0a2b283f1b9c569a3d1334431d010.svg";
export { ForwardRef as ReactComponent };